import { render, staticRenderFns } from "./partners-edit.vue?vue&type=template&id=71cc607f&scoped=true&"
import script from "./partners-edit.ts?vue&type=script&lang=ts&"
export * from "./partners-edit.ts?vue&type=script&lang=ts&"
import style0 from "./partners-edit.scss?vue&type=style&index=0&id=71cc607f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc607f",
  null
  
)

export default component.exports